import { KeyValueModel } from "model";
import { EnumFiltroContasBancarias } from "model/enums/enum-filtro-contas-bancarias";

export const FiltroContasBancariasMock: KeyValueModel[] = [
    new KeyValueModel(EnumFiltroContasBancarias.Banco, "Banco"),
    new KeyValueModel(EnumFiltroContasBancarias.Agencia, "Agência"),
];